<template>
  <NewAuthLayout cover-image="i-login-cover-2">
    <!-- <span slot="cover">
      <div class="h-100">
        <div class="h-80 d-flex align-items-end">
          <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center">
            <span class="i-evollu-big-white"></span>
          </div>
        </div>
        <div class="h-20 pl-md-5 d-flex flex-column justify-content-center align-items-center">
          <a href="#" class="scroll-text" v-scroll-to="{el: '#element', duration: 2000}">LOGIN</a>
          <i class="scroll-icon fa fa-angle-down" v-scroll-to="{el: '#element', duration: 2000}"></i>
        </div>
      </div>
    </span> -->
    <span slot="main">
      <div id="element" class="new-login">
        <h2>{{ $t('auth.welcome') }}</h2>
        <div v-show="error" class="error">{{ error }}</div>
        <form v-on:submit.prevent="login">
          <input :placeholder="$t('auth.email')" type="text" id="email" required="required" v-model="data.body.email"/>
          <div class="password-input">
            <input :placeholder="$t('auth.password')" :type="passwordFieldType" id="password" required="required" v-model="data.body.password"/>
            <span class="align-middle">
              <span :class="{'i-evollu-password-show': passwordFieldType === 'password', 'i-evollu-password-hide': passwordFieldType === 'text'}" class="password-show-hide" @click="switchVisibility"></span>
            </span>
          </div>
          <div class="form-group remember-me">
            <va-checkbox
              :label="$t('auth.remember')"
              :id="'checkbox-remember-me'"
              :isCircle="true"
              v-model="data.rememberMe"/>
          </div>
          <span v-if="successMessage" class="password-success">{{ successMessage }}</span>
          <div v-show="warning" class="warning">{{ warning }}</div>
          <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
            <button class="btn btn-primary btn-block login-button" type="submit" :disabled="isLoading" >
              {{$t('auth.login')}}
            </button>
          </div>
        </form>
        <!-- <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
          <div>
            <span>
              <b>{{ 'auth.forgotPassword' | translate}}&nbsp; <router-link to="recover">{{ 'auth.clickHere' | translate }}</router-link></b>
            </span>
          </div>
        </div> -->
        <div class="loading" :class="{'invisible': !isLoading}">
          <hollow-dots-spinner
            :animation-duration="2500"
            :size="60"
            color="#29c4a9"
          />
        </div>
      </div>
    </span>
    <span slot="footer">
      <span>
        <b>
          {{ $t('auth.forgotPassword') }}&nbsp;
          <router-link to="recover">{{ $t('auth.clickHere') }}.</router-link>
        </b>
      </span>
    </span>
  </NewAuthLayout>
</template>

<script>
import NewAuthLayout from '../NewAuthLayout'
import { HollowDotsSpinner } from 'epic-spinners'
import Vue from 'vue'
import LocalStorageHelper from '../../../local-storage/LocalStorageHelper'
import * as LocalStorageKeys from '../../../local-storage/LocalStorageKeys'
import EventBus from '@/utils/EventBus'
import ApiService from '@/api/ApiService';
// import VueScrollTo from 'vue-scrollto'

// Vue.use(VueScrollTo)

export default {
  name: 'NewLogin',
  components: {
    NewAuthLayout,
    HollowDotsSpinner
  },
  props: ['message'],
  data () {
    return {
      data: {
        body: {
          email: '',
          password: '',
          grant_type: 'password',
          client_id: '1',
          client_secret: 'secretp@ssword'
        },
        rememberMe: false
      },
      successMessage: this.message,
      error: null,
      warning: null,
      isLoading: false,
      passwordFieldType: 'password'
    }
  },
  methods: {
    login () {
      this.warning = null
      this.isLoading = true
      EventBus.$once('user-without-permissions', () => {
          this.warning = this.$t(`server_auth.errors.user_without_permissions`)
          this.isLoading = false
      })
      var redirect = this.$auth.redirect()
      var userLang = window.navigator.language || window.navigator.userLanguage
      var encodedCredentials = btoa(this.data.body.client_id + ':' + this.data.body.client_secret)

      const headers = {
        'Content-Type': 'application/json',
        'Accept-Language': userLang,
        'Authorization': 'Basic ' + encodedCredentials
      }

      /*ApiService.post(`${this.$store.state.evollauth_server}/token`, this.data.body, headers)
        .then(res => {
          LocalStorageHelper.set(LocalStorageKeys.REFRESH_AUTH_TOKEN, res.data.refresh_token)
          //console.log('Auth Successfully done')
          //console.log('Token: ' + this.$auth.token())

          if(res.data.requires_2fa) {
            this.$store.commit('SET_REQUIRES_2FA', res.data.requires_2fa)
          }
          if(this.$store.state.requires_2fa === true && this.$store.state.loggedUser === null) {
            setTimeout(() => {
              this.$router.replace({name: 'auth2FA'})
            }, 1)
            return
          }

          if (!redirect && this.$auth.user().redirect) {
            // this.$router.replace(redirect.from.name)
            this.$router.replace({ name: this.$auth.user().redirect })
          } else {
            this.$auth.fetch()
            this.$auth.fetch()
          }
        })
        .catch(err => {
          this.isLoading = false
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(err.response.status)
            // console.log(err.response.data)
            // console.log(err.response.headers)
            // console.log(err)
            if(err.response.status === 423) {
              //Locked user
              const splitMessage = err.response.data.message.split('--')
              this.error = this.$t(`server_auth.errors.${splitMessage[0].trim().replace(/ /g, '_').toLowerCase()}`, {date: splitMessage[1]})
            }
            else if (err.response.data.error) {
              this.error = this.$t(`server_auth.errors.${err.response.data.error_description.replace(/ /g, '_').toLowerCase()}`)
            } else if (err.response.data.message) {
              this.error = this.$t(`server_auth.errors.${err.response.data.message.replace(/ /g, '_').toLowerCase()}`)
            } else {
              if (err.response.status === 401) {
                this.error = this.$t(`server_auth.errors.${err.response.data.errors[0].msg.replace(/ /g, '_').toLowerCase()}`)
              } else {
                this.error = this.$t(`server_auth.errors.authentication_failed`)
              }
            }
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
            this.error = this.$t(`server_auth.errors.authentication_failed`)
          }
        })*/


      this.$auth.login({
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': userLang,
          'Authorization': 'Basic ' + encodedCredentials
        },
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: null,
        //redirect: { name: redirect ? redirect.from.name : this.$auth.user().redirect },
        success (res) {
          LocalStorageHelper.set(LocalStorageKeys.REFRESH_AUTH_TOKEN, res.data.refresh_token)


          if(res.data.requires_2fa) {
            this.$store.commit('SET_REQUIRES_2FA', res.data.requires_2fa)
          }
          if(this.$store.state.requires_2fa === true && this.$store.state.loggedUser === null) {
            this.$router.replace({name: 'auth2FA'})
            return
          }

          if (!redirect && this.$auth.user().redirect) {
            // this.$router.replace(redirect.from.name)
            this.$router.replace({ name: this.$auth.user().redirect })
          } else {
            this.$auth.fetch()
          }
        },
        error (err) {
          this.isLoading = false
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(err.response.status)
            // console.log(err.response.data)
            // console.log(err.response.headers)
            // console.log(err)
            if(err.response.status === 423) {
              //Locked user
              const splitMessage = err.response.data.message.split('--')
              this.error = this.$t(`server_auth.errors.${splitMessage[0].trim().replace(/ /g, '_').toLowerCase()}`, {date: splitMessage[1]})
            }
            else if (err.response.data.error) {
              this.error = this.$t(`server_auth.errors.${err.response.data.error_description.replace(/ /g, '_').toLowerCase()}`)
            } else if (err.response.data.message) {
              this.error = this.$t(`server_auth.errors.${err.response.data.message.replace(/ /g, '_').toLowerCase()}`)
            } else {
              if (err.response.status === 401) {
                this.error = this.$t(`server_auth.errors.${err.response.data.errors[0].msg.replace(/ /g, '_').toLowerCase()}`)
              } else {
                this.error = this.$t(`server_auth.errors.authentication_failed`)
              }
            }
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
            this.error = this.$t(`server_auth.errors.authentication_failed`)
          }
          // console.log(err.config)
        }
      })
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  },
  mounted () {
    var userLang = window.navigator.language || window.navigator.userLanguage
    userLang = userLang.toLowerCase().slice(0, 2)
    switch (userLang) {
    case 'pt':
      Vue.i18n.set('pt')
      break
    case 'es':
      Vue.i18n.set('es')
      break
    case 'en':
    default:
      Vue.i18n.set('en')
      break
    }
  },
  watch: {
    message: {
      handler: function () {
        setTimeout(() => {
          this.successMessage = null
        }, 3000)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .i-evollu-big-white {
    max-width: 80vw;
    max-height: 60vh;
  }
  .new-login {
    @include media-breakpoint-down(lg) {
      padding-right: 1rem;
      padding-left: 1rem;
    }
    @include media-breakpoint-down(md) {
      width: 100vw;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
      margin-bottom: 2rem;
      font-weight: bold;
    }
    width: 21.375rem;

    input {
      width: 100%;
      height: 2.5rem;
      padding-left: 20px;
      margin-bottom: 1.5rem;
      background-color: #E8E8E8;
      color: #414141;
      border: none;
      &::placeholder {
        color: #6E6E6E;
      }
      &:focus {
        outline: 0;
      }
    }

    .password-input {
      background-color: #E8E8E8;
      margin-bottom: 1.5rem;
      .password-show-hide {
        cursor: pointer;
      }
      input {
        width: calc(100% - 32px);
        margin-bottom: 0;
        margin-right: 3px;
      }
    }

    .down-container {
      margin-top: 3.125rem;
    }
    .warning,.error{
      text-align: center;
      margin-bottom: 1rem;
      word-wrap:break-word;
    }

    .error {
      color:red;
    }

    .warning{
      color: orange;
    }

    .login-button {
      text-transform: uppercase;
      letter-spacing: 3px;
      padding: 1.1rem 3.9rem;
      font-size: 1rem;
      line-height: 1.25;
      border-radius: 1.875rem;
    }
  }

  .loading {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 40%;
    left: 50%;
  }

  .password-success{
    display: flex;
    justify-content: center;
    font-weight: bold;
    color: #29c4a9;
  }

  .scroll-text {
    color: #fafafaff;
    font-size: 1.2rem;
    cursor: pointer;
    &:hover {
      color: #E8E8E8;
    }
  }

  .scroll-icon {
    color: #fafafaff;
    font-size: 3rem;
    cursor: pointer;
    &:hover {
      color: #E8E8E8;
    }
  }

  .remember-me {
    label {
      color: #6e6e6e;
    }
    .va-checkbox .va-checkbox__input{
      margin-bottom: 0;
      box-shadow: 0px 0px 7px 0px #c5c5c5 !important;
      border: none !important;
      background-color: #f5f5f5 !important;
    }
    .va-checkbox .active .va-icon{
      color: #414146;
    }
  }

  // .remember-me {
  //   label {
  //     color: #6e6e6e;
  //   }
  //   // background color
  //   .abc-checkbox label::before {
  //     box-shadow: 0px 0px 7px 0px #c5c5c5;
  //     border: none;
  //     background-color: #f5f5f5;
  //     width: 20px;
  //     height: 20px;
  //   }

  //   // checked background color
  //   .abc-checkbox-primary input[type="checkbox"]:checked + label::before {
  //     background-color: #f5f5f5;
  //     box-shadow: 0px 0px 7px 0px #c5c5c5;
  //     border: none;
  //   }

  //   // check color
  //   .abc-checkbox-primary input[type="checkbox"]:checked + label::after {
  //     color: #414146;
  //     font-size: 13px;
  //     top: 2px;
  //     left: 3px;
  //   }
  // }

  .h-20 {
    height: 20% !important;
  }

  .h-80 {
      height: 80% !important;
  }

</style>
